{
  "phone": "Phone",
  "location": "Location",
  "complete": "Complete your profile",
  "timezone": "Timezone",
  "accountHasBeenVerified": "Please complete some information about you.",
  "start": "Start using Otakus",
  "done": "On boarding done",
  "use_now": "You can now start to use otakus",
  "step_1": "Create an account",
  "step_1_description": "Choose a name for your account.",
  "name": "Name",
  "account_name": "Account name"
}
